import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description?: string;
  /** Kanonik yol, örn. '/gizlilik' (alan adı otomatik eklenir) */
  path?: string;
  /** Arama motorları dizine eklemesin (giriş, panel, 404 gibi sayfalar) */
  noindex?: boolean;
}

const SITE = 'https://klinikvet.app';

const setMeta = (selector: string, attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/** Sayfa başına başlık, açıklama, kanonik adres ve robots yönergesi ayarlar; sayfadan çıkınca eski değerleri geri yükler. */
export const useSeo = ({ title, description, path, noindex }: SeoOptions) => {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDesc = descEl?.getAttribute('content') ?? null;
    const canonEl = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const prevCanon = canonEl?.getAttribute('href') ?? null;
    const robotsEl = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const prevRobots = robotsEl?.getAttribute('content') ?? null;

    document.title = title;
    if (description) {
      setMeta('meta[name="description"]', 'name', 'description', description);
      setMeta('meta[property="og:description"]', 'property', 'og:description', description);
    }
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    if (path) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', SITE + path);
      setMeta('meta[property="og:url"]', 'property', 'og:url', SITE + path);
    }
    setMeta('meta[name="robots"]', 'name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

    return () => {
      document.title = prevTitle;
      if (prevDesc != null) setMeta('meta[name="description"]', 'name', 'description', prevDesc);
      if (prevCanon != null) document.head.querySelector('link[rel="canonical"]')?.setAttribute('href', prevCanon);
      if (prevRobots != null) setMeta('meta[name="robots"]', 'name', 'robots', prevRobots);
    };
  }, [title, description, path, noindex]);
};
